import * as React from "react";
import { Route, Switch } from "react-router-dom";

import LimitHits from "./Fraud.LimitHits";
import TopMerchants from "./Fraud.TopMerchants";
import TopDevices from "./Fraud.TopDevices";
import SusDevices from "./Fraud.SusDevices";
import SusWithdrawals from "./Fraud.SusWithdrawals";
import SusCardLoads from "./Fraud.SusCardLoads";
import MerchantLimitConfigs from "./Fraud.MerchantLimitConfigs";
import WalletP2p from "./Fraud.WalletP2p";
import WalletSpend from "./Fraud.WalletSpend";

const Fraud = (props) => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/fraud/limit_hits"
      render={() => <LimitHits {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/fraud/top_merchants"
      render={() => <TopMerchants {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/fraud/top_devices"
      render={() => <TopDevices {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/fraud/suspicious_withdrawals"
      render={() => <SusWithdrawals {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/fraud/suspicious_devices"
      render={() => <SusDevices {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/fraud/suspicious_card_loads"
      render={() => <SusCardLoads {...props} />}
    />
    <Route
      path="/snapscan/fraud/merchant_limit_configs"
      render={() => <MerchantLimitConfigs {...props} />}
    />
    <Route
      path="/snapscan/fraud/wallet_p2p"
      render={() => <WalletP2p {...props} />}
    />
    <Route
      path="/snapscan/fraud/wallet_spend"
      render={() => <WalletSpend {...props} />}
    />
  </Switch>
);

export default Fraud;
